import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

/** Privacy requests (R0b W8): a core capability, no module switch applies (ADR-025). */
export const Route = createFileRoute('/_app/privacy-requests')({
  staticData: { crumb: 'privacyRequests' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'privacy.dsr'),
  component: Outlet,
})
